import React from 'react';
import { m } from 'framer-motion';
import { SectionTag } from '../ui/SectionTag';
import { lookInsideImages } from '../../data/content';
export function LookInside() {
  return <section className="bg-white py-10 sm:py-14" data-id="element-98" data-mp="1xbs5ar9chqub">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-99" data-mp="1xdmrsa09lr0i">
        <SectionTag icon="👀" data-id="element-100" data-mp="1sl1zjcx0blz3">Vistazo al interior</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-extrabold uppercase leading-tight text-navy sm:text-4xl" data-id="element-101" data-mp="1sjihbgrsj0uo">
          Echa un vistazo al material que llevarás mañana al aula
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-102" data-mp="22d7tutaqefhg">
          Diapositivas visuales, explicaciones paso a paso y ejercicios listos para proyectar.
        </p>
      </div>

      <div className="mx-auto mt-8 max-w-6xl px-4 sm:px-6" data-id="element-103" data-mp="2b9qgjnsdd75l">
        <div className="scrollbar-hide flex snap-x snap-mandatory gap-5 overflow-x-auto pb-2" data-id="element-104" data-mp="lxy2vd3gahx2">
          {lookInsideImages.map((image, i) => <m.div key={image.src} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i % 3 * 0.08
        }} className="aspect-[1/1.414] w-[220px] flex-shrink-0 snap-center overflow-hidden rounded-xl border border-navy/5 bg-white shadow-card sm:w-[260px]" data-id="element-105" data-mp="h050yw96ka2l" data-mpi={i}>
              <img src={image.src} alt={image.alt} loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-106" data-mp="3se3lh6971iub" />
            </m.div>)}
        </div>
        <p className="mt-3 text-center text-xs text-muted sm:hidden" data-id="element-107" data-mp="649cgfei7glc">← Desliza para ver más ejemplos →</p>
      </div>
    </section>;
}